import { PublicClientApplication, type AccountInfo } from "@azure/msal-browser";
import { reactive } from "vue";
import {getEnvVariable} from '../utils/env-variable-helper';

const config = {
  auth: {
    clientId: getEnvVariable("VUE_APP_AZURE_AUTH_CLIENT_ID"),
    authority: getEnvVariable("VUE_APP_AZURE_AUTH_AUTHORITY"),
    redirectUri: window.location.origin + "/auth/callback", 
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: window.location.origin,    
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

const data = reactive({
  account: null as AccountInfo | null,
  msalInstance: new PublicClientApplication(config),
  token: ""
});

export function useAuth() {
  return data;
}